var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInprogress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 0.334473C3.31828 0.334473 0.333984 3.31974 0.333984 7.00114C0.333984 10.6835 3.31853 13.6683 7.00065 13.6683C10.6825 13.6683 13.6673 10.6835 13.6673 7.00114C13.6673 3.31974 10.6825 0.334473 7.00065 0.334473ZM7.00065 1.0859C10.262 1.0859 12.9159 3.73976 12.9159 7.00111C12.9159 10.2629 10.262 12.9168 7.00065 12.9168C3.73882 12.9168 1.08543 10.2629 1.08543 7.00111C1.08543 3.73976 3.73882 1.0859 7.00065 1.0859Z",
    fill: "#003DA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92269 6.38537C4.26278 6.52628 4.42425 6.91613 4.28341 7.25622C4.14251 7.59625 3.75265 7.75778 3.41256 7.61688C3.07254 7.47604 2.911 7.08619 3.0519 6.74609C3.19274 6.406 3.5826 6.24453 3.92269 6.38537Z",
    fill: "#003DA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2557 6.38537C7.59579 6.52628 7.75726 6.91613 7.61642 7.25622C7.47551 7.59625 7.08566 7.75778 6.74557 7.61688C6.40554 7.47604 6.24401 7.08619 6.38491 6.74609C6.52575 6.406 6.91561 6.24453 7.2557 6.38537Z",
    fill: "#003DA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5887 6.38537C10.9288 6.52628 11.0903 6.91613 10.9494 7.25622C10.8085 7.59625 10.4187 7.75778 10.0786 7.61688C9.73855 7.47604 9.57701 7.08619 9.71792 6.74609C9.85876 6.406 10.2486 6.24453 10.5887 6.38537Z",
    fill: "#003DA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogress);
export default __webpack_public_path__ + "static/media/inprogress.c0a162bec97e66b23fee98ce8a9cb037.svg";
export { ForwardRef as ReactComponent };